const fontFamily = [
  "Roboto",
  "Apple SD Gothic Neo",
  '"돋움"',
  "Dotum",
  "Helvetica Neue",
  "arial",
  "sans-serif",
].join(", ");

const fontFamilyWithNotoSans = [
  "Noto Sans KR",
  "Apple SD Gothic Neo",
  '"돋움"',
  "Dotum",
  "Helvetica Neue",
  "arial",
  "sans-serif",
].join(", ");

export const defaultTheme = {
  zIndex: {
    LEVEL_10: 10000,
    LEVEL_9: 5000,
    LEVEL_8: 2500,
    LEVEL_7: 100,
    LEVEL_6: 50,
    LEVEL_5: 25,
    LEVEL_4: 10,
    LEVEL_3: 1,
    LEVEL_2: 0,
    LEVEL_1: -10000,
  },
  breakPoint: {
    XL: "1921px",
    LG: "1681px",
    MD: "1001px",
    MS: "834px",
    SM: "433px",
  },
  fontFamily: {
    default: fontFamily,
    notoSans: fontFamilyWithNotoSans,
  },
  desktop: {
    fontSize: "14px",
    h1: "40px",
    h2: "36px",
    h3: "24px",
    h4: "20px",
    h5: "18px",
    h6: "14px",
    p: "14px",
  },
  color: {
    font: "#333333",
    gray: "#bfbfbf",
    primary: "#379CD5",
    sub: "#1E5299",
    danger: "#ff4d4f",
  },
};
